import WorkshopList from '../../components/workshops/list/WorkshopList';
import WorkshopsWithRegistrationBlock from '../../home/blocks/WorkshopsWithRegistrationBlock';
import WorkshopTable from '../components/WorkshopTable/WorkshopTable';

export const workshopListComponents = {
  'grid': WorkshopList,
  'table': WorkshopTable,
  'with-registration': WorkshopsWithRegistrationBlock,
};
